import NamedDto from 'modules/base/dto/NamedDto';

export class UnitOptimizerStateInjectEditDto extends NamedDto {
    constructor() {
        super();

        /** @type {number} */
        this.type = null;

        /** @type {string} */
        this.value = null;
    }

    /**
     * @typedef {Object} _UnitOptimizerStateInjectEditDtoProps
     * @property {number} type
     * @property {string} value
     *
     * @typedef {import("modules/base/dto/NamedDto").NamedDtoProps & _UnitOptimizerStateInjectEditDtoProps} UnitOptimizerStateInjectEditDtoProps
     */
    /**
     *
     * @param {UnitOptimizerStateInjectEditDtoProps} props
     * @returns {UnitOptimizerStateInjectEditDto}
     */
    setup(props) {
        super.setup(props);

        this.type = props.type;
        this.value = props.value;

        return this;
    }
}

export default UnitOptimizerStateInjectEditDto;